import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';

export interface ErrorDialogData {
  title: string;
  message: string;
  btnLabel?: string;
  btnUrl?: string;
}

@Component({
  selector: 'app-error-dialog',
  standalone: true,
  imports: [MatDialogModule],
  templateUrl: './error-dialog.component.html',
})
export class ErrorDialogComponent {
  readonly dialogRef = inject(MatDialogRef<ErrorDialogComponent>);
  readonly data = inject<ErrorDialogData>(MAT_DIALOG_DATA);

  close(): void {
    this.dialogRef.close();
  }

  onButtonClick(): void {
    if (this.data.btnUrl) {
      window.open(this.data.btnUrl, '_blank');
    }
    this.close();
  }
}
